"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CtaWrapStyled = exports.ChatPlaceholderStyled = exports.ChatButtonStyled = exports.ListStyled = exports.LinkStyled = exports.StoreHoursStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _list = require("@dbi-tools/ui-kit/lib/list");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n\n  .LPMcontainer {\n    margin: 0 !important;\n    white-space: nowrap !important;\n  }\n\n  .button-inner {\n    ", ";\n    text-transform: lowercase;\n    font-weight: ", ";\n    background-color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex !important;\n  flex-wrap: wrap;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  cursor: pointer;\n  color: ", ";\n  text-decoration: underline !important;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none !important;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline !important;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none !important;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  svg {\n    flex-shrink: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StoreHoursStyled = _uiKit.styled.div(_templateObject());

exports.StoreHoursStyled = StoreHoursStyled;
var LinkStyled = (0, _uiKit.styled)('a')(_templateObject2(), _uiKit.Colors.primary, _uiKit.Colors.wine);
exports.LinkStyled = LinkStyled;
var linkStyle = (0, _uiKit.css)(_templateObject3(), _uiKit.Colors.primary, _uiKit.Colors.wine);
var ListStyled = (0, _uiKit.styled)(_list.ListItemStyled)(_templateObject4());
exports.ListStyled = ListStyled;

var ChatButtonStyled = _uiKit.styled.div(_templateObject5(), linkStyle, _uiKit.FontWeightValue.light, _uiKit.Colors.white);

exports.ChatButtonStyled = ChatButtonStyled;

var ChatPlaceholderStyled = _uiKit.styled.span(_templateObject6(), _uiKit.Colors.gray600);

exports.ChatPlaceholderStyled = ChatPlaceholderStyled;

var CtaWrapStyled = _uiKit.styled.div(_templateObject7());

exports.CtaWrapStyled = CtaWrapStyled;